export const environment = {
    production: false,
    apiUrlVendorHub: 'https://test-vendorhub-api.meloni.sm',
    // altre configurazioni specifiche per l'ambiente di test
  };